<div class="tab-content leave-page">
  <div class="page-title">
    <span translate>EMPLOYEE_LEAVE</span>
    <span class="page-actions">
      <a [routerLink]="['./../allocate']" class="btn btn-success">
        <i class="pi pi-plus" aria-hidden="true"></i>
        <span translate>ALLOCATE_LEAVE</span>
      </a>
    </span>
  </div>
  <ng-container
    *ngIf="!fullscreen"
    [ngTemplateOutlet]="timeline"
  ></ng-container>
  <div class="table-view">
    <p-tabs [(value)]="listTab">
      <p-tablist>
        <p-tab value="pending">
          <span translate>LEAVE_LIST_TABS.PENDING_APPROVALS</span>
          <span class="leave-tab-scope" translate
            >LEAVE_LIST_TABS.ALL_DATES</span
          >
          <span class="leave-tab-count">{{ pendingLeaves.length }}</span>
        </p-tab>
        <p-tab value="period">
          <span translate>LEAVE_LIST_TABS.SELECTED_PERIOD</span>
          <span class="leave-tab-scope leave-tab-scope--range"
            >{{ dayPilotStartDate | date: "dd/MM/yyyy" }} –
            {{ dayPilotEndaDate | date: "dd/MM/yyyy" }}</span
          >
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="pending">
          <ng-container
            [ngTemplateOutlet]="leaveTable"
            [ngTemplateOutletContext]="{ rows: pendingLeaves, pending: true }"
          ></ng-container>
        </p-tabpanel>
        <p-tabpanel value="period">
          <ng-container
            [ngTemplateOutlet]="leaveTable"
            [ngTemplateOutletContext]="{ rows: periodLeaves, pending: false }"
          ></ng-container>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

<!-- Both tabs share one table layout; each instance keeps its own filters and sort. -->
<ng-template #leaveTable let-rows="rows" let-pending="pending">
  <p-table
    [styleClass]="
      pending
        ? 'leave-details-table leave-details-table--pending'
        : 'leave-details-table leave-details-table--period'
    "
    [scrollable]="true"
    [tableStyle]="{ minWidth: '70rem' }"
    #dt
    [value]="rows"
    #leavesTable
    [rows]="10"
    [paginator]="true"
    [pageLinks]="3"
    [rowsPerPageOptions]="[5, 10, 20]"
    [sortField]="pending ? 'StartDate' : undefined"
    [sortOrder]="1"
    exportFilename="Employee Leave Details"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
  >
    <!-- Caption -->
    <ng-template pTemplate="caption">
      <div class="ui-helper-clearfix">
        <div class="table-options">
          <div class="pull-left"></div>
          <div class="pull-right">
            <div class="action-btns-group">
              <kuba-export
                [reportData]="leavesTable.filteredValue || leavesTable.value"
                [additionalData]="additionalData"
              ></kuba-export>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="EmployeeName">
          {{ "EMPLOYEE_NAME" | translate }}
          <p-sortIcon field="EmployeeName"></p-sortIcon>
        </th>
        <th pSortableColumn="StartDate">
          {{ "START_DATE" | translate }}
          <p-sortIcon field="StartDate"></p-sortIcon>
        </th>
        <th pSortableColumn="EndDate">
          {{ "END_DATE" | translate }}
          <p-sortIcon field="EndDate"></p-sortIcon>
        </th>
        <th pSortableColumn="NoOfDays">
          {{ "NO_OF_DAYS" | translate }}
          <p-sortIcon field="NoOfDays"></p-sortIcon>
        </th>
        <th>{{ "STATUS" | translate }}</th>
        <th>{{ "APPROVAL_PERSON" | translate }}</th>
        <th pSortableColumn="AprDate">
          {{ "DATE_APPROVAL" | translate }}
          <p-sortIcon field="AprDate"></p-sortIcon>
        </th>
        <th width="95px"><span translate>DESCRIPTION</span></th>
        <th width="84px">{{ "OPTIONS" | translate }}</th>
      </tr>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            (input)="
              dt.filter($any($event.target)?.value, 'EmployeeName', 'contains')
            "
            placeholder=""
            class="p-column-filter"
          />
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th>
          <!-- Every pending row is Open, so the status filter only applies to the period list. -->
          <p-select
            *ngIf="!pending"
            [options]="statusList"
            (onChange)="dt.filter($event.value, 'Status', 'equals')"
            styleClass="p-column-filter"
            [placeholder]="'SELECT' | translate"
            [showClear]="true"
            appendTo="body"
          >
            <ng-template let-status pTemplate="item">
              {{ status.label | translate }}
            </ng-template>
          </p-select>
        </th>
        <th>
          <p-select
            width="118px"
            [options]="approvalPersonList"
            (onChange)="
              dt.filter($event.value, 'ApprovalPersonNameList', 'equals')
            "
            styleClass="p-column-filter"
            placeholder=""
            [showClear]="true"
            appendTo="body"
          >
            <ng-template let-employee pTemplate="item">
              {{ employee.label | translate }}
            </ng-template>
          </p-select>
        </th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <!-- Body Content -->
    <ng-template pTemplate="body" let-employee>
      <tr>
        <td>
          <span class="text-overflow">{{ employee.EmployeeName }}</span>
        </td>
        <td>
          <span>{{ employee.StartDate | date: "dd/MM/yyyy" }}</span>
        </td>
        <td>
          <span>{{ employee.EndDate | date: "dd/MM/yyyy" }}</span>
        </td>
        <td>
          <span>{{ employee.NoOfDays }}</span>
        </td>
        <td>
          <span
            class="leave-status"
            [class.leave-approved]="employee.Status === 6"
            [class.leave-open]="employee.Status === 8"
            [class.leave-rejected]="employee.Status === 10"
            translate
            >{{ employee.StatusText }}</span
          >
        </td>
        <td>
          <span class="text-overflow">{{
            employee.ApprovalPersonNameList
          }}</span>
        </td>
        <td>
          <span>{{ employee.ApprovedDate | date: "dd/MM/yyyy" }}</span>
        </td>
        <td class="col-button">
          <span
            *ngIf="employee.Description != ''"
            pTooltip="{{ employee.Description }}"
            tooltipPosition="top"
            class="btn btn-icon"
          >
            <i class="pi pi-comment" aria-hidden="true"></i>
          </span>
        </td>
        <td class="col-button">
          <button
            type="button"
            [routerLink]="['./../editLeave', employee.Id]"
            title="{{ 'EDIT' | translate }}"
            [attr.aria-label]="'EDIT' | translate"
            class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"
          >
            <i class="pi pi-pencil"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <!-- Empty message -->
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td colspan="9">
          {{
            (pending ? "LEAVE_LIST_TABS.NO_PENDING" : "NO_RECORDS_FOUND")
              | translate
          }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<ng-template #timeline>
  <section
    class="leave-timeline"
    [attr.aria-label]="'EMPLOYEE_LEAVE' | translate"
  >
    <form
      [formGroup]="DayPilotForm"
      (ngSubmit)="Search()"
      class="leave-filters"
    >
      <div class="form-group">
        <label for="leave-from" translate>FROM_DATE</label>
        <p-datepicker
          inputId="leave-from"
          formControlName="DayPilotStartDate"
          [showIcon]="true"
          [showButtonBar]="true"
          dateFormat="dd/mm/yy"
          [placeholder]="'SELECT_START_DATE' | translate"
          appendTo="body"
        ></p-datepicker>
      </div>
      <div class="form-group">
        <label for="leave-to" translate>END_DATE</label>
        <p-datepicker
          inputId="leave-to"
          formControlName="DayPilotEndDate"
          [showIcon]="true"
          [showButtonBar]="true"
          dateFormat="dd/mm/yy"
          [placeholder]="'SELECT_END_DATE' | translate"
          appendTo="body"
        ></p-datepicker>
      </div>
      <button type="submit" class="btn btn-primary" [disabled]="loading">
        <span translate>SEARCH</span>
      </button>
    </form>
    <div class="leave-toolbar">
      <div class="leave-period-actions">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="changeDayPilotHeader(3)"
          [disabled]="loading"
          translate
        >
          YEAR
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="changeDayPilotHeader(2)"
          [disabled]="loading"
          translate
        >
          MONTH
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="changeDayPilotHeader(1)"
          [disabled]="loading"
          translate
        >
          WEEK
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="moveRange(-1)"
          [disabled]="loading"
          [attr.aria-label]="'PREVIOUS' | translate"
        >
          <i class="pi pi-chevron-left" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="moveRange(1)"
          [disabled]="loading"
          [attr.aria-label]="'NEXT' | translate"
        >
          <i class="pi pi-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
      <div class="leave-view-actions">
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveDayPilotEvents()"
          [disabled]="loading || modifiedEmployeeLeaves.length === 0"
        >
          <span translate>SAVE</span
          ><span *ngIf="modifiedEmployeeLeaves.length">
            ({{ modifiedEmployeeLeaves.length }})</span
          >
        </button>
        <button
          *ngIf="!fullscreen"
          type="button"
          class="btn btn-outline-primary"
          (click)="fullscreen = true"
          translate
        >
          EXPAND
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="exportLeaveDataToExcel()"
          [disabled]="loading"
        >
          <span translate>EXPORT_TO</span> <span translate>EXCEL</span>
        </button>
      </div>
    </div>
    <p-table
      [value]="resourcesList"
      dataKey="id"
      [scrollable]="true"
      [scrollHeight]="fullscreen ? '60vh' : '32rem'"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 20, 50]"
      [pageLinks]="3"
      [loading]="loading"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'SUMMARY_TOTALRECORDS' | translate"
      styleClass="leave-resource-table"
      [tableStyle]="{
        width:
          'max(100%, calc(var(--leave-fixed-width) + var(--leave-day-width) * ' +
          events.length +
          '))',
        tableLayout: 'fixed',
        '--leave-day-count': events.length
      }"
    >
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col class="leave-avatar-column" />
          <col class="leave-name-column" />
          <col class="leave-days-column" />
          <col class="leave-days-column" />
          <col
            *ngFor="let day of events; trackBy: trackDate"
            class="leave-day-column"
          />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pFrozenColumn rowspan="2" class="leave-avatar-column">
            <span class="sr-only" translate>EMPLOYEE</span>
          </th>
          <th pFrozenColumn rowspan="2" class="leave-name-column" translate>
            NAME
          </th>
          <th pFrozenColumn rowspan="2" class="leave-days-column">
            <span translate>ALLOCATED_DAYS</span><small>{{ getYear }}</small>
          </th>
          <th
            pFrozenColumn
            rowspan="2"
            class="leave-days-column leave-frozen-edge"
          >
            <span translate>REMAINING_DAYS</span><small>{{ getYear }}</small>
          </th>
          <th
            *ngFor="let month of groupedlist"
            [attr.colspan]="month.length"
            class="leave-month-heading"
          >
            <span
              [pTooltip]="
                dateLabel(month[0], { month: 'long', year: 'numeric' })
              "
              >{{
                dateLabel(month[0], { month: "long", year: "numeric" })
              }}</span
            >
          </th>
        </tr>
        <tr>
          <th
            *ngFor="let day of events; trackBy: trackDate"
            class="leave-day-column"
            [class.leave-weekend]="day.getDay() === 0 || day.getDay() === 6"
          >
            <span>{{ dateLabel(day, { weekday: "short" }) }}</span
            ><strong>{{ day.getDate() }}</strong>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-employee>
        <tr>
          <td pFrozenColumn class="leave-avatar-column">
            <img
              [src]="employee.profileImg || 'assets/icons/default_profile.jpg'"
              alt=""
              class="leave-avatar"
              (error)="onAvatarError($event)"
            />
          </td>
          <td pFrozenColumn class="leave-name-column">
            <span [pTooltip]="employee.name">{{ employee.name }}</span>
          </td>
          <td pFrozenColumn class="leave-days-column">
            {{ employee.days ?? "—" }}
          </td>
          <td pFrozenColumn class="leave-days-column leave-frozen-edge">
            {{ employee.remainingDays ?? "—" }}
          </td>
          <td [attr.colspan]="events.length" class="leave-track-cell">
            <div
              class="leave-track"
              (dragover)="$event.preventDefault()"
              (drop)="dropLeave($event, employee.id)"
            >
              <ng-container *ngIf="leaveLanes(employee.id) as lanes">
                <div
                  *ngFor="let lane of lanes; trackBy: trackIndex"
                  class="leave-lane"
                >
                  <button
                    *ngFor="let leave of lane; trackBy: trackLeave"
                    type="button"
                    class="leave-span"
                    [class.leave-approved]="leave.Status === 6"
                    [class.leave-open]="leave.Status === 8"
                    [class.leave-rejected]="leave.Status === 10"
                    [style.left.%]="leaveLeft(leave)"
                    [style.width]="'calc(' + leaveWidth(leave) + '% - 4px)'"
                    [pTooltip]="leaveTooltip(leave)"
                    tooltipPosition="top"
                    tooltipEvent="both"
                    tooltipStyleClass="leave-range-tooltip"
                    appendTo="body"
                    [attr.aria-label]="leaveTooltip(leave)"
                    [draggable]="leave.Status === 8 && !loading"
                    (dragstart)="beginLeaveDrag($event, leave)"
                    (click)="selectLeave(leave)"
                  >
                    <span class="leave-label"
                      >{{ statusKey(leave.Status) | translate }} ·
                      {{ leave.NoOfDays }} {{ "DAYS" | translate }}</span
                    >
                    <span
                      *ngIf="leave.Status === 8"
                      class="leave-resize-handle"
                      draggable="true"
                      (dragstart)="beginLeaveDrag($event, leave, true)"
                      (click)="$event.stopPropagation()"
                      aria-hidden="true"
                    ></span>
                  </button>
                </div>
                <div *ngIf="lanes.length === 0" class="leave-lane"></div>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"
        ><tr>
          <td [attr.colspan]="events.length + 4" translate>NO_RECORDS_FOUND</td>
        </tr></ng-template
      >
    </p-table>
  </section>
</ng-template>

<p-dialog
  [(visible)]="fullscreen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="'EMPLOYEE_LEAVE' | translate"
  [style]="{ width: '96vw', height: '92vh' }"
  styleClass="leave-timeline-dialog"
>
  <ng-container *ngIf="fullscreen" [ngTemplateOutlet]="timeline"></ng-container>
</p-dialog>
<p-dialog
  [(visible)]="displayMenu"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="'LEAVE_DETAILS' | translate"
  [style]="{ width: '30rem' }"
>
  <ng-container *ngIf="currentEvent">
    <p class="leave-details-summary">{{ leaveTooltip(currentEvent) }}</p>
    <div class="leave-view-actions">
      <a
        class="btn btn-outline-primary"
        [routerLink]="['./../editLeave', currentEvent.Id]"
        ><span translate>EDIT</span></a
      >
      <button
        type="button"
        class="btn btn-outline-primary"
        [disabled]="loading"
        (click)="changeLeaveStatus(8)"
        translate
      >
        OPEN
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        [disabled]="loading"
        (click)="changeLeaveStatus(6)"
        translate
      >
        APPROVED
      </button>
      <button
        type="button"
        class="btn btn-outline-primary"
        [disabled]="loading"
        (click)="changeLeaveStatus(10)"
        translate
      >
        REJECTED
      </button>
    </div>
  </ng-container>
</p-dialog>
<p-confirmDialog
  [header]="'CONFIRMATION' | translate"
  icon="pi pi-question-circle"
  [acceptLabel]="'SWITCH_YES' | translate"
  [rejectLabel]="'SWITCH_NO' | translate"
></p-confirmDialog>
